export default {
  index: '首頁',
  summary: '申請概要',
  applicationList: '申請列表',
  studentQuery: '學生查詢',
  studentManagement: '代理學生管理',
  studentRegister: '新增學生',
  studentInfo: '學生個人信息',
  studentInfoManagement: '學生資料管理',
  studentApplicationForm: '學生申請匯總',
  commissionManagement: '傭金管理',
  informationCenter: '資訊中心',
  newsInfo: '新聞資訊',
  institutionInfo: '院校資訊',
  institutionInformationDetail: '院校資訊詳情',
  videoCenter: '視頻中心',
  newsInfoEntrance: '新聞資訊入口',
  newsInfoDetail: '新聞資訊詳情',
  quickViewMPS: '快速查看Commission',

  businessOverview: '業務總覽',
  businessStatistics: '業務統計',
  financialSettlement: '財務結算',
  mpsManagement: '院校佣金',
  resourceManagement: '院校資源',
  applicationFee: '院校資源信息',
  languageReq: '接受的語言類型',
  companySetting: '公司設置',
  setting: '設置',
  studentInformation: '學生專頁',
  contactPerson: '聯系負責人',
};
